import React from 'react';
import { columns } from './columns';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/_table/Table/Table';

const PointLogModal = (props) => {
  const { isOpen, closeModal, pointLog, getList } = props;
  const { list, pagination } = pointLog;

  return (
    <Modal
      title="포인트 로그 내역"
      isOpen={isOpen}
      width={960}
      height={600}
      isFooter={true}
      okText="확인"
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <Table
        columns={columns}
        rowKey={(record) => record.id}
        list={list}
        pagination={pagination}
        size="small"
        getList={getList}
        scroll={{ x: true }}
        bordered={true}
      />
    </Modal>
  );
};

export default PointLogModal;
